<template>
    <div class="verify">
        <div class="tip" v-show="item.tip">{{ item.tip }}</div>
        <div class="check">
            <div class="input-area">
                <el-form-item :key="item.name" :label="item.title"
                              :prop="item.name">
                    <el-input @input="changeValue"  v-model="code" :placeholder="item.placeholder" ></el-input>
                </el-form-item>
            </div>
            <div class="operation">
                <el-button @click="send" :disabled="time>0" type="primary" size="mini">发送验证码{{time?time:''}}</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['item','value'],
    data() {
        return {
            time: 0,
            code: '',
            timer: '',
            loading:false,
        }
    },
    mounted() {
        this.code = '';
        this.timer=setInterval(()=>{
            if (this.time>0){
                this.time--;
            }else{
                this.loading=false;
            }
        },1000);
        this.time = 0;
    },
    methods: {
        send:function (){
            if (this.$store.state.loading||this.loading) {
                return;
            }
            this.loading=true;
            this.$bbs.post(this.item.url,{},{need:{error:true,progress:true}}).then(()=>{
                this.time=120;
            });
        },
        changeValue(){
          this.$emit('input',this.code);
        },
    },
    beforeDestroy() {
        this.loading=false;
        clearInterval(this.timer);
    }
}
</script>
<style scoped lang="less">
.tip{
    padding-left: 130px;
}
    .check{
        display: flex;
        align-items: flex-start;
        .input-area{
            flex: 1;
        }
        .operation{
            padding:6px 0 0 10px;
            flex-shrink: 0;
            width: 120px;
        }
    }
</style>